import React, {useEffect, useState} from "react";
import Link from '@mui/material/Link';
import {Button} from '@mui/material';
import {Swiper, SwiperSlide, useSwiper} from "swiper/react";
import {makeStyles} from '@mui/styles';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import 'swiper/css'
import "swiper/css/navigation";
import "swiper/css/pagination";

const MyPagination = ({t}) => {
    const swiper = useSwiper()

    const [isBeginning, setIsBeginning] = useState(swiper.isBeginning)
    const [isEnd, setIsEnd] = useState(swiper.isEnd)

    swiper.on('slideChange', () => {
        setIsBeginning(swiper.isBeginning)
        setIsEnd(swiper.isEnd)
    })

    return (
        <div className="flex justify-end mt-4">
            <Button variant={'text'} size={'medium'} disabled={isBeginning}
                    className="min-w-0 mr-2 text-black hover:text-primary"
                    onClick={() => swiper.slidePrev()}>
                <FontAwesomeIcon icon={solid('chevron-left')}/>
            </Button>
            <Button variant={'text'} size={'medium'} disabled={isEnd}
                    className="min-w-0 text-black hover:text-primary"
                    onClick={() => swiper.slideNext()}>
                <FontAwesomeIcon icon={solid('chevron-right')}/>
            </Button>
        </div>
    )
}

export default function MySlider({dataList, title, subTitle, showAll, showArrows, href,
                                   itemComponent: ItemComponent, baseUrl, brandInfo, t}) {

    const [list, setList] = useState([])
    useEffect(() => {
        setList(dataList)
    }, [dataList])

    return (
        <div className='mb-7'>
            <div className="flex items-center mb-4">
                <div className="font-semibold grow text-lg">
                    {title}
                </div>
                {
                    showAll ?
                        <Link href={href} style={{ alignSelf: 'flex-end', display: 'flex', textDecoration: 'none' }}>
                            <h3 style={{ fontSize: 14, fontWeight: 400, color: '#7C7C7C', fontFamily: 'Montserrat' }}>{t('home:button_showall')}</h3>
                        </Link> : null
                }
            </div>
            {
                subTitle === undefined ?
                    null :
                    <div className="flex items-center mb-4">
                        <h3 style={{ alignSelf: 'flex-start', fontSize: 14, fontWeight: 400, color: '#7C7C7C', fontFamily: 'Montserrat' }}>{subTitle}</h3>
                    </div>
            }

            <Swiper
                loop={false}
                slidesPerView={1}
                slidesPerGroup={1}
                spaceBetween={15}
                autoHeight
                breakpoints={{
                    700: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    }
                }}
            >
                {
                    list.map((item, i) => (
                        <SwiperSlide key={i}>
                            <ItemComponent t={t} brandInfo={brandInfo} type={item.__typename} data={item} baseUrl={baseUrl === '/services' ? `${baseUrl}/listing` : baseUrl === '/stores' ? `${baseUrl}` : `${baseUrl}/${item.category}`} />
                        </SwiperSlide>
                    ))
                }
                {
                    showArrows ? <MyPagination slot="container-end"/> : null
                }
            </Swiper>
        </div>
    )
}
